var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{key:_vm.tag._id,staticClass:"ArticleTagListTag",attrs:{"to":_vm.localePath({ name: 'articleTag-slug', params: { slug: _vm.tag.page_meta.slug }})}},[_vm._v(" "+_vm._s(_vm.tag.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }